import React from 'react';
import dayjs from 'dayjs';
import { cn } from '../../../../../utils/styles';
import Link from '../../../../../components/Common/UI/Link';
import Separator from '../../../../../components/Common/UI/Separator';
import { PdfViewerTrigger } from '../../../../../context/pdfViewerDialog';

export interface FooterItem {
  path: string;
  label: string;
  type?: 'link' | 'pdf'; // by default link
}

export const defaultFooterItems: FooterItem[] = [
  {
    path: '#',
    label: 'Copyright/IP Policy',
  },
  {
    path: '#',
    label: 'Terms of Service',
  },
  {
    path: '#',
    label: 'Site Map',
  },
  {
    path: '#',
    label: 'Help',
  },
  {
    path: '#',
    label: 'Send Feedback',
  },
  {
    path: '#',
    label: 'Contact Us',
  },
];

// use this footer when wrap application on 'Statements' step
export const innerFooterItems: FooterItem[] = [
  {
    path: '/financialInstitution/Consumer_Rights_Summary_Page.pdf',
    label: 'Consumer Rights Summary',
    type: 'pdf',
  },
  {
    path: '/financialInstitution/Guidance_privacy_policy.pdf',
    label: 'Privacy Policy',
    type: 'pdf',
  },
];

interface FooterProps {
  items?: FooterItem[];
  copyrightText?: React.ReactNode;
}

export default function InstitutionFooter({ items, copyrightText }: FooterProps) {
  return (
    <footer id="auth-footer" className={cn(['flex flex-col gap-4 items-center mx-auto mt-6 pb-4', 'text-muted'])}>
      <div className="flex gap-4 flex-wrap justify-center">
        {(items?.length ? items : defaultFooterItems).map(({ label, path, type }, index, arr) => (
          <React.Fragment key={`${path}${label}`}>
            {type === 'pdf' ? (
              <PdfViewerTrigger src={path}>
                <a href="#" onClick={e => e.preventDefault()}>
                  {label}
                </a>
              </PdfViewerTrigger>
            ) : (
              <Link key={path} to={path} variant="muted">
                {label}
              </Link>
            )}
            {index !== arr.length - 1 ? <Separator orientation="vertical" className="h-auto w-[2px]" /> : null}
          </React.Fragment>
        ))}
      </div>
      <div className="text-xs">
        Copyright © {dayjs().format('YYYY')} {copyrightText}
      </div>
    </footer>
  );
}

InstitutionFooter.defaultProps = {
  items: undefined,
  copyrightText: 'Financial Institution. All rights reserved.',
};
